import { api } from './api'

function assertSuccess(body: unknown) {
  const b = body as { success?: boolean; message?: string; data?: unknown }
  if (!b?.success) {
    throw new Error(b?.message || 'Request failed')
  }
  return b.data
}

function apiError(err: unknown, fallback: string) {
  const e = err as { response?: { data?: { message?: string } }; message?: string }
  return new Error(e?.response?.data?.message || e?.message || fallback)
}

export type PlatformDashboardOverview = {
  organisations: {
    total: number
    active: number
    inactive: number
    suspended: number
  }
  activeStores: number
  pendingWithdrawals: number
  newsletterSubscriberTotal: number
  recentOrganisations: Array<{
    id: string
    name: string
    slug: string
    status: string
    createdAt: string
  }>
  recentNewsletterSignups: Array<{
    id: number
    email: string
    storeId: number
    storeName: string | null
    organisationName: string | null
    subscribedAt: string
  }>
  recentWindowDays: number
}

export async function fetchPlatformDashboardOverview(): Promise<PlatformDashboardOverview> {
  try {
    const { data } = await api.get('/admin/platform/dashboard')
    return assertSuccess(data) as PlatformDashboardOverview
  } catch (e) {
    throw apiError(e, 'Failed to load platform dashboard')
  }
}
